angular.module('impactx.MenuDirectives').directive('ixBasketInfo', function () {
    return {
        restrict: 'A',
        templateUrl: 'shared/menu/templates/basketinfo-menu.tmpl.html'
    }
});